/**
 * MAPERFUME sticky add-to-cart bar (mobile-first, product page).
 *
 * Design notes:
 * - The sticky button submits the SAME <form> as the main add-to-cart button
 *   via the native HTML `form="…"` attribute, so the existing `product-form`
 *   custom element (assets/product-form.js) handles the actual AJAX add-to-
 *   cart request. No cart logic is duplicated here.
 * - Price/availability state is kept in sync by subscribing to the theme's
 *   existing PUB_SUB_EVENTS.variantChange event (published by
 *   assets/product-info.js on every variant update), not by re-implementing
 *   variant/price logic.
 * - The sticky variant <select> (only rendered when the product has more
 *   than one variant) never decides availability itself: on change it sets
 *   the matching values on the real, native option controls inside
 *   <variant-selects> and dispatches a native `change` event, letting the
 *   theme's own VariantSelects/ProductInfo classes do the work.
 */
(function () {
  function initStickyAtc(root) {
    var sectionId = root.dataset.sectionId;
    if (!sectionId) return;

    var trigger = document.getElementById(root.dataset.watch);
    if (!trigger || !('IntersectionObserver' in window)) return;

    var priceEl = document.getElementById('MpStickyPrice-' + sectionId);
    var button = document.getElementById('MpStickyAtcButton-' + sectionId);
    var buttonText = button ? button.querySelector('span') : null;
    var variantSelect = document.getElementById('MpStickyVariant-' + sectionId);
    var variantSelectsEl = document.querySelector('variant-selects[data-section="' + sectionId + '"]');

    function show() {
      root.hidden = false;
      root.classList.add('mp-sticky-atc--visible');
    }

    function hide() {
      root.classList.remove('mp-sticky-atc--visible');
    }

    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        if (entry.isIntersecting) {
          hide();
        } else if (entry.boundingClientRect.top < 0) {
          // The add-to-cart area has been scrolled up and out of view.
          show();
        } else {
          // Not reached yet (below the viewport) - keep hidden.
          hide();
        }
      },
      { threshold: 0 }
    );
    observer.observe(trigger);

    // Stay in sync with variant changes made anywhere (main picker or this
    // sticky select) via the theme's own pub/sub channel.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (!event || !event.data || String(event.data.sectionId) !== String(sectionId)) return;

        var variant = event.data.variant;
        var html = event.data.html;

        if (priceEl && html && html.getElementById) {
          var newPrice = html.getElementById('price-' + sectionId);
          if (newPrice) priceEl.innerHTML = newPrice.innerHTML;
        }

        if (button) {
          var strings = window.variantStrings || {};
          if (!variant) {
            button.setAttribute('disabled', 'disabled');
            if (buttonText) buttonText.textContent = strings.unavailable || 'Unavailable';
          } else if (variant.available === false) {
            button.setAttribute('disabled', 'disabled');
            if (buttonText) buttonText.textContent = strings.soldOut || 'Sold out';
          } else {
            button.removeAttribute('disabled');
            if (buttonText) buttonText.textContent = strings.addToCart || 'Add to cart';
          }
        }

        if (variantSelect && variant && variant.id != null && variantSelect.value !== String(variant.id)) {
          variantSelect.value = String(variant.id);
        }
      });
    }

    if (variantSelect && variantSelectsEl) {
      variantSelect.addEventListener('change', function () {
        var variantsJson = document.getElementById('MpStickyVariantsJSON-' + sectionId);
        if (!variantsJson) return;

        var variants;
        try {
          variants = JSON.parse(variantsJson.textContent);
        } catch (e) {
          return;
        }

        var targetId = this.value;
        var variant = variants.filter(function (v) {
          return String(v.id) === String(targetId);
        })[0];
        if (!variant || !variant.options) return;

        var optionNodes = Array.prototype.filter.call(variantSelectsEl.children, function (el) {
          return el.tagName === 'FIELDSET' || (el.tagName === 'DIV' && el.classList.contains('product-form__input'));
        });

        var lastChanged = null;
        variant.options.forEach(function (optionValue, index) {
          var node = optionNodes[index];
          if (!node) return;

          var select = node.querySelector('select');
          if (select) {
            if (select.value !== optionValue) {
              select.value = optionValue;
              lastChanged = select;
            }
            return;
          }

          var radios = node.querySelectorAll('input[type="radio"]');
          radios.forEach(function (radio) {
            if (radio.value === optionValue && !radio.checked) {
              radio.checked = true;
              lastChanged = radio;
            }
          });
        });

        if (lastChanged) {
          lastChanged.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
  }

  function init() {
    document.querySelectorAll('.mp-sticky-atc[data-section-id]').forEach(initStickyAtc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
